import React, { useState, useEffect } from "react";
import Datatable from "../Components/Datatable"
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useAuth } from '../../../../context/AuthContext';
import Swal from 'sweetalert2'
import { API_BASE_URL } from "../../../../Helpers/apiConfig";

const formatDate = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return isoString;
    return date.toLocaleString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};

function SchoolTeacherList() {
    const [data, setData] = useState([]);
    const [deletedteachers, setdeletedteachers] = useState([]);
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t } = useTranslation()

    const columns = React.useMemo(
        () => [
            {
                Header: t('email'),
                Footer: t('email'),
                accessor: 'username', // accessor is the "key" in the data
            },
            {
                Header: t('namesurname'),
                Footer: t('namesurname'),
                accessor: 'fullName',
            },
            {
                Header: "Sorumlu Sınıf",
                Footer: "Sorumlu Sınıf",
                accessor: 'className',
            },
            {
                Header: "Not",
                Footer: "Not",
                accessor: 'userNote',
            },
            {
                Header: t('createdAt'),
                Footer: t('createdAt'),
                accessor: (originalRow) => formatDate(originalRow.createdAt),
                id: 'createdAt',
            },
            {
                Header: t('lastLogin'),
                Footer: t('lastLogin'),
                accessor: (originalRow) => formatDate(originalRow.lastLogin),
                id: 'lastLogin',
            },
            {
                Header: "Aksiyonlar",
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex align-items-center gap-2">
                        <button
                            className="btn btn-info btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t('editteacher')}
                        </button>
                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDelete(originalRow)}
                        >
                            {t('deleteteacher')}
                        </button>
                    </div>
                ),
                id: 'action',
                Footer: "Aksiyonlar",
            },
        ],
        [],
    )

    const handleEdit = (row) => {
        window.location.href = "/school/editteacher/" + row['id'];
    }

    const handleDelete = async (row) => {
        setLoading(true);
        try {
            const headerss = {
                "accept": "*/*",
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials': 'false',
                'Authorization': 'Bearer ' + user.token
            }
            let url = `${API_BASE_URL}/manager/EditSchool/DeleteLecturer?lecturerId=` + row['id'];
            await axios({
                method: 'Delete',
                url: url,
                headers: headerss
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                    else {
                        setMsg(res.data['message']);
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err);
        }
        setLoading(false);
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            let classes = [];
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = `${API_BASE_URL}/manager/EditSchool/GetClasses`;
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200 && res.data['success']) {
                        classes = res.data['data'];
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = `${API_BASE_URL}/manager/EditSchool/GetLecturers`;
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            for (let i = 0; i < res.data['data'].length; i++) {
                                const lecturerId = res.data['data'][i]['id'];
                                const assignedClass = classes.find(c => c['lecturerId'] === lecturerId);
                                const row = {
                                    "id": lecturerId,
                                    "username": res.data['data'][i]['username'],
                                    "fullName": res.data['data'][i]['fullName'],
                                    "className": assignedClass ? assignedClass['className'] : "-",
                                    "userNote": res.data['data'][i]['userNote'] || "-",
                                    "createdAt": res.data['data'][i]['createdAt'],
                                    "lastLogin": res.data['data'][i]['lastLogin'],
                                };
                                if (res.data['data'][i]['isDeleted'] === false) {
                                    data.push(row)
                                }
                                else {
                                    deletedteachers.push(row)
                                }
                            }
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }
        fetchData();

    }, []);
    //TODO:İSDELETED EKLENECEK
    return (
        <div style={{ backgroundColor: "white", width: "full" }} >
            <div style={{ textAlign: "center" }}>
                <h3>{msg}</h3>
                <h1>{t("activeteachersList")}</h1>
                {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                {!loading && (
                    <div>
                        <Datatable data={data} columns={columns} tableBaslik={t("teachersList")} />
                    </div>
                )}
            </div>

            <br />
            <div style={{ textAlign: "center" }}>
                <h3>{msg}</h3>
                <h1>{t("deletedteachersList")}</h1>
                {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                {!loading && (
                    <div>
                        <Datatable data={deletedteachers} columns={columns} tableBaslik={t("teachersList")} />
                    </div>
                )}
            </div>
        </div>
    );
}
export default SchoolTeacherList;
